var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

require('isomorphic-fetch');

var assets = {};
var cacheExpiration = 10 * 1000;

var AssetPrice =
/*#__PURE__*/
function () {
  "use strict";

  function AssetPrice(symbol) {
    _classCallCheck(this, AssetPrice);

    this.symbol = symbol;
    this.lastFetch = 0;
    this.lastPrice = null;
  }

  _createClass(AssetPrice, [{
    key: "getPrice",
    value: function () {
      var _getPrice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var price;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(Date.now() - this.lastFetch < cacheExpiration)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.lastPrice);

              case 2:
                price = this.fetchPrice();
                this.lastPrice = price;
                this.lastFetch = Date.now();
                return _context.abrupt("return", price);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPrice() {
        return _getPrice.apply(this, arguments);
      }

      return getPrice;
    }()
  }, {
    key: "fetchPrice",
    value: function () {
      var _fetchPrice = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var symbol, url, result, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                symbol = this.symbol.toUpperCase();
                url = "https://min-api.cryptocompare.com/data/price?fsym=".concat(symbol, "&tsyms=USD");
                _context2.next = 4;
                return fetch(url);

              case 4:
                result = _context2.sent;
                _context2.next = 7;
                return result.json();

              case 7:
                data = _context2.sent;
                return _context2.abrupt("return", data.USD);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPrice() {
        return _fetchPrice.apply(this, arguments);
      }

      return fetchPrice;
    }()
  }]);

  return AssetPrice;
}();

module.exports.getPrice =
/*#__PURE__*/
function () {
  var _getPrice2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(symbol) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!assets[symbol]) {
              assets[symbol] = new AssetPrice(symbol);
            }

            return _context3.abrupt("return", assets[symbol].getPrice());

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  function getPrice(_x) {
    return _getPrice2.apply(this, arguments);
  }

  return getPrice;
}();